import { format } from "date-fns";
import { useLocalStorageState } from "../hooks/localStorage";
import { useFormik } from "formik";
import { useEffect, useState } from "react";

export interface WellLevelViewFormValues {
  sites: string[];
  startDate: string;
  endDate: string;
}

const initialFormValues: WellLevelViewFormValues = {
  sites: [],
  startDate: "2018-01-28",
  endDate: format(new Date(), "yyyy-MM-dd"),
};

export function useWellLevelsStorageData() {
  return useLocalStorageState({ key: "wellLevelsView", value: initialFormValues });
}

export function useWellLevelsForm() {
  const [initialValues, handleUpdateForm] = useWellLevelsStorageData();
  const [formValues, setFormValues] = useState(initialValues);

  const formik = useFormik({
    initialValues,
    onSubmit: (values) => setFormValues(values),
  });

  useEffect(() => {
    handleUpdateForm(formik.values);
  }, [formik.values, handleUpdateForm]);

  return { formik, formValues };
}
